export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const HARDCODED_TARGET_IMPORT = 'IMPORT';
export const HARDCODED_TARGET_RULE = 'RULE';
export const HARDCODED_INVOICE_TARGET = 'INVOICE';
export const HARDCODED_TARGET_ID_RULE_EDITOR = 'INVOICE_RULE';
export const NEW = 'New';
export const UPDATE = 'Update';
export const SLIDING_PANEL_DIALOG_TITLE = 'Close without saving';
export const SLIDING_PANEL_DIALOG_TEXT = 'Changes you made will not be saved when this panel is closed.';
export const SLIDING_PANEL_DIALOG_ACTION_LABEL = 'CLOSE PANEL';
export const SLIDING_PANEL_DIALOG_CONTENT_CLASS_NAME = 'sliding-panel__dialog-text';
export const SLIDING_PANEL_DIALOG_TITLE_CLASS_NAME = 'sliding-panel__dialog-title';
export const S1_PORTAL_URL = 'S1_PORTAL_URL';
export const USER_ORG = 'userOrg';
export const USER_INFO = 'userInfo';
export const ORG_TREE = 'orgTree';
export const OTP_TOKEN = 'otpToken';
export const JWT_TOKEN = 'jwtToken';
export const INVOICE_FILTERS = 'invoiceFilters';
export const VISIBLE_INVOICE_COLUMNS = 'visibleInvoiceColumns';
export const EXTRA_COLUMNS = 'extraColumns';



// WEBPACK FOOTER //
// ./src/shared/constants/SharedConstants.js